export default {
  '请求': {
    '加载中': 'Laden...',
    '请求失败': 'Anfrage fehlgeschlagen',
    '登录已过期': 'Sitzung abgelaufen',
    '网络连接失败': 'Netzwerkverbindung fehlgeschlagen',
    '请重新登录': 'Bitte erneut anmelden',
    '没有权限访问': 'Zugriff verweigert',
    '请求的资源不存在': 'Ressource nicht gefunden',
    '服务器错误': 'Serverfehler',
    '网络错误': 'Netzwerkfehler',
    '刷新成功': 'Aktualisiert',
    '获取中': 'Wird geladen......',
    '账号下线': 'Konto offline',
    '功能已禁用': 'Funktion deaktiviert',
  },
  '导航': {
    '首页': 'Start',
    '选妃': 'Auswählen',
    '认证': 'Verifizieren',
    '影院': 'Video',
    '个人': 'Mein',
  },
  '首页': {
    '注册': 'Registrieren',
    '影片': 'Video',
    '女团': 'Girls',
    '热门城市': 'Beliebte Städte:',
    '经理预订': 'Manager-Buchung',
    '看更多': 'Mehr',
    '身份验证': 'Verifiziert',
    '身高': 'Größe',
    '胸围': 'Brust',
    '服务城市': 'Stadt:',
  },
  '女团': {
    '女团': 'Girls',
    '选妃': 'Auswählen',
    '身份验证': 'Verifiziert',
    '身高': 'Größe',
    '胸围': 'Brust',
    '服务城市': 'Stadt:',
    '注册': 'Registrieren',
    '请联系顾问或接待员': 'Bitte Berater oder Empfang kontaktieren',
  },
  '登录': {
    '登录会员视窗': 'Mitglieder-Login',
    '请输入用户名': 'Benutzername',
    '请输入密码': 'Passwort',
    '登录': 'Anmelden',
    '没有账号马上注册': 'Kein Konto? Registrieren',
    '登录成功': 'Anmeldung erfolgreich',
    '登录注册': 'Anmelden / Registrieren',
    '登录可享受更多服务': 'Anmelden für mehr Services!',
  },
  '注册': {
    '注册': 'Registrieren',
    '登录': 'Anmelden',
    '请输入用户名': 'Benutzername',
    '用户名规则': '6–20 Buchstaben/Zahlen',
    '请输入密码': 'Passwort',
    '密码规则': '6–16 Zeichen und Zahlen',
    '请输入验证码': 'Captcha',
    '验证码规则': '4-stelliges Captcha eingeben',
    '请输入邀请码': 'Einladungscode',
    '邀请码规则': 'Agenten-Einladungscode eingeben',
    '同意协议': 'Ich bin 18+ und stimme den AGB zu',
    '立即注册': 'Jetzt registrieren',
    '注册中': 'Registrierung...',
    '已有账号马上登录': 'Konto vorhanden? Anmelden',
    '注册成功': 'Registriert!',
    '注册失败': 'Registrierung fehlgeschlagen: ',
    '验证码错误': 'Ungültiges Captcha',
    '请同意注册条款': 'Bitte AGB akzeptieren',
    '用户名已存在': 'Benutzername existiert bereits',
    '邀请码无效': 'Ungültiger Einladungscode',
  },
  '抢单': {
    '今日收益': 'Heutige Einnahmen',
    '余额': 'Guthaben',
    '订单': 'Aufträge',
    '开始抢单': 'Auftrag holen',
    '当前等级': 'Stufe:',
    '提现': 'Auszahlen',
    '在线客服': 'Support',
    '充值': 'Aufladen',
    '幸运任务': 'Glücksaufgabe',
    '幸运订单': 'Glücksauftrag',
    '幸运订单提示': 'Glückwunsch! Dies ist ein Auftrag mit hoher Provision',
    '恭喜获得幸运订单': 'Glücksauftrag erhalten!',
    '提交订单': 'Auftrag absenden',
    '未完成订单提示': 'Sie haben einen offenen Auftrag. Bitte zuerst bezahlen.',
    '正在获取订单': 'Auftrag wird geladen...',
    '抢单时间': 'Holzeit:',
    '订单号': 'Auftragsnr.',
    '订单总额': 'Gesamt',
    '佣金': 'Provision',
    '商品单价': 'Preis',
    '预计收入': 'Geschätzte Einnahmen',
    '确认支付': 'Jetzt zahlen',
    '确认付款': 'Zahlung bestätigen',
    '支付处理中': 'Wird verarbeitet...',
    '取消': 'Abbrechen',
    '去查看': 'Ansehen',
    '暂无可用订单': 'Keine verfügbaren Aufträge',
    '正在加载用户信息': 'Benutzerdaten werden geladen...',
    '今日抢单已达上限': 'Tageslimit erreicht',
    '余额不足无法获取订单': 'Unzureichendes Guthaben',
    '获取订单失败': 'Auftrag konnte nicht geladen werden',
    '支付成功': 'Zahlung erfolgreich',
    '支付失败': 'Zahlung fehlgeschlagen',
    '支付失败请重试': 'Zahlung fehlgeschlagen, bitte erneut versuchen',
    '请完成任务单后进入': 'Bitte zuerst Aufgaben abschließen',
    '请设置收款卡': 'Bitte Auszahlungsadresse hinterlegen',
  },
  '我的': {
    '我的页面': 'Meine Seite',
    '钻石': 'Diamant',
    '信誉分': 'Kreditscore',
    '开通专属会员': 'VIP aktivieren',
    '开启一次日期不限': 'Einmal freischalten, kein Datumslimit',
    '提现': 'Auszahlen',
    '历史订单': 'Auftragshistorie',
    '充值记录': 'Aufladeverlauf',
    '提现记录': 'Auszahlungsverlauf',
    '添加钱包地址': 'Wallet-Adresse hinzufügen',
    '邀请码': 'Einladungscode:',
    '余额': 'Guthaben',
    '退出登陆': 'Abmelden',
  },
  '会员': {
    '会员等级': 'Mitgliedschaft:',
    '普通等级': 'Standard',
    '当前等级': 'Aktuell',
    '立即开通': 'Jetzt aktivieren',
    '免费说明': '(Kostenlose Videos) (Kostenloses Matching)',
    '所需投资': 'Erforderlich',
    '佣金': 'Provision',
    '订单': 'Aufträge',
    '加入': 'Beitreten >>',
  },
  '充值': {
    '充值': 'Aufladen',
    '当前余额': 'Guthaben',
    '余额': 'Guthaben: ',
    '个': '',
    '充值金额': 'Betrag',
    '请输入充值金额': 'Betrag eingeben',
    '快速选择金额': 'Schnellbetrag',
    '确认': 'Bestätigen',
    '提示': 'Hinweis',
    '金额错误': 'Ungültiger Betrag',
    '立即充值': 'Jetzt aufladen',
    '提交成功': 'Eingereicht, Prüfung ausstehend',
  },
  '提现': {
    '提现': 'Auszahlen',
    '兑换积分': 'Punkte auszahlen',
    '最大提款金额': 'Maximalbetrag',
    '资金密码': 'Fondspasswort',
    '余额': 'Guthaben: ',
    '个': '',
    '钱包地址': 'Wallet-Adresse: ',
    '请选择提款地址': 'Auszahlungsadresse wählen',
    '暂无绑定地址': 'Noch keine Adresse hinterlegt',
    '提交': 'Absenden',
    '通知': 'Hinweis:',
    '单笔最大提现': '1. Max. pro Auszahlung: ',
    '单笔最低提现': '2. Min. pro Auszahlung: ',
    '检查姓名账号': '3. Name und Konto prüfen',
    '注意提款费用': '4. Auszahlungsgebühren beachten',
    '请填写正确的金额': 'Gültigen Betrag eingeben',
    '当前余额': 'Guthaben',
    '提现金额': 'Betrag',
    '请输入提现数量': 'Betrag eingeben',
    '立即提现': 'Jetzt auszahlen',
    '交易密码': 'Zahlungspasswort',
    '请输入交易密码': 'Zahlungspasswort eingeben',
    '请先设置提现密码': 'Bitte zuerst Auszahlungspasswort festlegen',
  },
  '绑卡': {
    '添加钱包地址': 'Wallet-Adresse hinzufügen',
    '钱包地址信息': 'Wallet-Adresse',
    '请输入支付卡信息': 'Wallet-Adresse eingeben',
    '加密货币类型': 'Krypto-Typ',
    '请选择加密货币类型': 'Krypto-Typ wählen',
    '钱包地址': 'Wallet-Adresse',
    '请输入钱包地址': 'Wallet-Adresse eingeben',
    '绑卡说明': 'Sehr geehrter Nutzer, bitte hinterlegen Sie Ihren echten Namen und legen Sie ein Auszahlungspasswort fest. Der Name muss mit dem Konto übereinstimmen.',
    '确定绑卡': 'Verknüpfung bestätigen',
    '绑卡提示': 'Tipp: große Bank hinterlegen. Zur Änderung Support kontaktieren.',
    '请先设置姓名': 'Bitte zuerst den Namen festlegen!',
    '已绑定不可修改': 'Adresse bereits hinterlegt. Zur Änderung Support kontaktieren.',
  },
  '订单历史': {
    '订单历史': 'Auftragshistorie',
    '数据为空': 'Keine Daten',
    '订单号': 'Auftragsnr.: ',
    '已完成': 'Abgeschlossen',
    '处理中': 'In Bearbeitung',
    '完成订单': 'Auftrag abschließen',
    '订单金额': 'Betrag: ',
    '佣金': 'Provision: ',
    '创建时间': 'Erstellt: ',
    '上一页': 'Zurück',
    '下一页': 'Weiter',
    '获取失败': 'Historie konnte nicht geladen werden',
    '获取失败重试': 'Laden fehlgeschlagen, bitte erneut versuchen',
    '未知': 'Unbekannt',
    '完成成功': 'Auftrag abgeschlossen!',
    '完成失败': 'Abschluss fehlgeschlagen: ',
    '完成失败重试': 'Abschluss fehlgeschlagen, bitte erneut versuchen',
    '请输入支付密码': 'Zahlungspasswort eingeben',
    '请先设置支付密码': 'Bitte zuerst Zahlungspasswort festlegen',
  },
  '入金记录': {
    '标题': 'Aufladeverlauf',
    '数据为空': 'Keine Daten',
    '认证结果': 'Ergebnis',
    '下单积分': 'Punkte: ',
    '下单时间': 'Bestellt: ',
    '结算时间': 'Abgerechnet: ',
    '待审核': 'Ausstehend',
    '已通过': 'Genehmigt',
    '已拒绝': 'Abgelehnt',
    '暂无数据': 'Keine Daten',
  },
  '提现记录': {
    '标题': 'Auszahlungsverlauf',
    '数据为空': 'Keine Daten',
    '待审核': 'Ausstehend',
    '审核成功': 'Genehmigt',
    '审核退回': 'Abgelehnt',
    '未知状态': 'Unbekannt',
    '金额': 'Betrag: ',
    '说明': 'Hinweis: ',
    '提交时间': 'Eingereicht: ',
    '审核时间': 'Geprüft: ',
    '已通过': 'Genehmigt',
    '已拒绝': 'Abgelehnt',
    '暂无数据': 'Keine Daten',
  },
  '资料': {
    '基本信息': 'Profil',
    '头像': 'Avatar',
    '姓名': 'Name',
    '未设置': 'Nicht festgelegt',
    '性别': 'Geschlecht',
    '男': 'Männlich',
    '女': 'Weiblich',
    '未知': 'Unbekannt',
    '设定': 'Einstellungen',
    '账号信息': 'Konto',
    '更改登录密码': 'Login-Passwort ändern',
    '设定支付密码': 'Zahlungspasswort festlegen',
    '退出登录': 'Abmelden',
    '设置': 'Einstellungen',
    '登录密码': 'Login-Passwort',
    '资金密码': 'Fondspasswort',
    '提现密码已设置': 'Auszahlungspasswort gesetzt. Zur Änderung Support kontaktieren.',
    '已设置': 'Gesetzt',
    '修改真实姓名': 'Echten Namen bearbeiten',
    '请输入真实姓名': 'Echten Namen eingeben',
    '真实姓名说明': 'Der echte Name muss mit den Wallet-Daten übereinstimmen',
    '提交': 'Absenden',
    '请勿重复设置': 'Bereits festgelegt!',
    '修改登录密码': 'Login-Passwort ändern',
    '设置资金密码': 'Fondspasswort festlegen',
    '保存': 'Speichern',
    '旧密码': 'Altes Passwort',
    '请输入旧密码': 'Altes Passwort eingeben',
    '新密码': 'Neues Passwort',
    '请输入新密码': 'Neues Passwort eingeben',
    '确认密码': 'Passwort bestätigen',
    '请再次输入新密码': 'Neues Passwort erneut eingeben',
    '请填写完整': 'Bitte alle Felder ausfüllen!',
    '两次密码不一致': 'Passwörter stimmen nicht überein',
    '性别修改': 'Geschlecht ändern',
    '个人报表': 'Persönlicher Bericht',
    '任务金额积分': 'Aufgabenbetrag (Punkte)',
    '盈利公式': 'Gewinn = Gewinnbetrag − Aufgabenbetrag',
    '任务金额': 'Aufgabenbetrag',
    '充值金额': 'Aufladung',
    '金额': 'Betrag',
    '中奖金额': 'Gewinnbetrag',
    '个人情报': 'Profil',
    '身高': 'Größe:',
    '胸围': 'Brust:',
    '收费区间': 'Preisspanne:',
    '系统公告': 'Ankündigungen',
  },
  '客服': {
    '联系客服': 'Support kontaktieren',
    '在线客服': 'Online-Support',
    '暂无客服': 'Kein Support verfügbar',
    '联系': 'Kontakt',
    '服务时间': '24/7 für Sie da',
  },
  '影院': {
    '影院': 'Kino',
    '全部': 'Alle',
    '最高分': 'Bestbewertet',
    '播放': 'Aufrufe: ',
    '次播放': ' Aufrufe',
    '热门推荐': 'Beliebt',
    '播放次数': 'Aufrufe:',
    '请充值后观看': 'Bitte aufladen, um zu schauen',
  },
  '语言切换器': {
    '切换语言': 'Sprache',
    '语言': 'Sprache',
  },
}
